import { useInView } from "framer-motion";

const useOverViewMenu = (
  ref: React.MutableRefObject<HTMLDivElement | null>
) => {
  const isInView = useInView(ref, { once: false, margin: "-300px" });

  return { isInView };
};

export default useOverViewMenu;
